module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-recept.911d48d5.png";